<script setup lang="ts">
import { UiButton, UiModal } from '@arpm/ui';

import { resolveConfirm, useConfirmState } from '@/composables/useConfirm.js';

const state = useConfirmState();

function onModel(value: boolean): void {
  if (!value) resolveConfirm(false);
}
</script>

<template>
  <UiModal
    :model-value="state.open"
    :title="state.options.title"
    @update:model-value="onModel"
    @close="resolveConfirm(false)"
  >
    <p v-if="state.options.text" class="text">{{ state.options.text }}</p>
    <div class="actions">
      <UiButton variant="secondary" @click="resolveConfirm(false)">
        {{ state.options.cancelLabel ?? 'Отмена' }}
      </UiButton>
      <UiButton
        :variant="state.options.danger ? 'danger' : 'primary'"
        @click="resolveConfirm(true)"
      >
        {{ state.options.confirmLabel ?? 'Подтвердить' }}
      </UiButton>
    </div>
  </UiModal>
</template>

<style scoped>
.text {
  margin: 0 0 var(--space-4);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
}
</style>
